<template>
  <el-scrollbar class="x_scroll" style="height: 100%">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <div class="content">
          <!-- 姓名/性别 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名:">
                <el-input
                  :disabled="type === 1"
                  type="text"
                  v-model="ruleForm.memberName"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别:">
                <el-radio-group
                  :disabled="type === 1"
                  v-model="ruleForm.memberSex"
                >
                  <el-radio label="1">男</el-radio>
                  <el-radio label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 出生日期/身份证号 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="出生日期:">
                <el-date-picker
                  :disabled="type === 1"
                  v-model="ruleForm.birthday"
                  @change="onChangeBirth"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号:" prop="idNo">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.idNo"
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!--会员手机号码/身高 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="会员手机号码:" prop="photoNumber">
                <el-input
                  :disabled="type === 1"
                  @blur="handleRepetition"
                  v-model="ruleForm.photoNumber"
                  placeholder="会员手机号码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="身高:" prop="height">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.height"
                  placeholder="身高"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" >
              <el-form-item label="体重:" prop="weight">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.weight"
                  placeholder="体重"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="医保卡号:" prop="medicalInsuranceCardNumber">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.medicalInsuranceCardNumber"
                  placeholder="医保卡号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="患者备注:" prop="memberRemark">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.memberRemark"
                  placeholder="患者备注"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 联系地址/详细地址 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="BMI:" prop="bmi">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.bmi"
                  placeholder="BMI"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="血型:" prop="bloodType">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.bloodType"
                  placeholder="血型"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="民族:" prop="nation">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.nation"
                  placeholder="民族"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="籍贯:" prop="nativePlace">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.nativePlace"
                  placeholder="籍贯"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系地址:" prop="areaList">
                <areaPicker
                  :disabled="type === 1"
                  :areaList="areaList"
                  @getAreaData="getAreaData"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="详细地址:" prop="homeAddress">
                <el-input
                  :disabled="type === 1"
                  v-model="ruleForm.homeAddress"
                  placeholder="请输入详细地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card class="box-card" v-for="item in visitDetail" :key="item.id">
        <div slot="header">
          <h4>{{ item.nodeName }}</h4>
          <span v-if="item.nodeName === '家族史'" class="illnessType"
            >(1 无 2 高血压 3 糖尿病 4 惯冠心病 5 慢性阻塞性肺疾病 6 恶心肿瘤 7
            脑卒中 8 重性精神疾病 9 结核病 10 肝炎 11 先天畸形 12 其他 )</span
          >
          <p v-if="item.nodeName === '家族史'" class="notice">
            提示: 请选择以上数字，如有多疾病，以；分开
          </p>
        </div>
        <el-col :span="12" v-for="sub in item.children" :key="sub.id">
          <el-form-item >
            <div slot="label">
              <span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="sub.remark ? sub.remark : ''"
                  placement="top-start"
                >
                  <i v-if="sub.remark" class="el-icon-question"></i>
                </el-tooltip>
                <span>{{ `${sub.nodeName}:` }}</span>
              </span>
            </div>
            <el-radio-group
              :disabled="type === 1"
              v-if="sub.inputValueFormat === 1"
              v-model="ruleForm[item.nodeCode][sub.nodeCode]"
            >
              <el-radio
                v-for="option in sub.options"
                :key="option.id"
                :label="option.id"
                >{{ option.optionValue }}</el-radio
              >
            </el-radio-group>
            <el-input
              :disabled="type === 1"
              v-else-if="sub.inputValueFormat === 0"
              v-model="ruleForm[item.nodeCode][sub.nodeCode]"
            ></el-input>
            <template v-else-if="sub.inputValueFormat === 5">
              <el-radio-group
                :disabled="type === 1"
                v-if="sub.nodeName === '药物不良反应'"
                v-model="ruleForm[item.nodeCode][sub.nodeCode]"
              >
                <el-radio
                  v-for="option in sub.options"
                  :key="option.id"
                  :label="option.id"
                  >{{ option.optionValue }}</el-radio
                >
                <el-input
                  v-show="ruleForm[item.nodeCode][sub.nodeCode] === 21"
                  v-model="ruleForm[item.nodeCode][`${sub.nodeCode}:remark`]"
                ></el-input>
              </el-radio-group>
              <el-date-picker
                :disabled="type === 1"
                v-if="sub.nodeName === '出生日期'"
                v-model="ruleForm[item.nodeCode][sub.nodeCode]"
                @change="onChangeBirth"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </template>
            <template v-else-if="sub.inputValueFormat === 2">
               <el-checkbox-group :disabled="type===1"  v-model="ruleForm[item.nodeCode][sub.nodeCode]">
                <el-checkbox  v-for="option in sub.options"
                  :key="option.id"
                  :label="option.id">
                  {{option.optionValue}}
                </el-checkbox>
              </el-checkbox-group>
            </template>
          </el-form-item>
        </el-col>
      </el-card>
      <el-card class="box-card" v-if="path==='memberDetail'">
        <div slot="header" class="clearfix">
          <span>会员信息</span>
        </div>
        <div>
          <!-- 来源药企/绑定门店 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="来源药企:">
                <span>{{memberEditData.enterpriseName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="绑定门店:">
                <span>{{memberEditData.storeName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 慢病情况/ 会员等级 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="慢病情况:">
                <template v-if="memberLabelList.length">
                  <el-tag
                    v-for="item in memberLabelList"
                    :key="item.id"
                    >{{ item.labelName }}</el-tag
                  >
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会员等级:">
                <el-radio-group v-model="memberDetail.memberLevel" disabled>
                  <el-radio :label="1">普通</el-radio>
                  <el-radio :label="2">付费VIP</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <p>
                <span>会员积分：</span>
                {{allIntegral}}<el-button type="danger" class="detailBtn" size="mini" @click="showJfPup">查看明细</el-button>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                <span>现金余额：</span>
                {{memberAccount.usableAmount}}<el-button type="danger" size="mini" class="detailBtn" @click="showAmountPup">查看明细</el-button>
              </p>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-form>
    <div v-if="type===2" class="btn">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSave">保存</el-button>
    </div>
    <el-dialog title="积分明细" :visible.sync="isShowJfPup" top="4vh">
      <el-form :inline="true" ref="jfQueryParams" class="demo-form-inline">
        <el-form-item label="时间" prop="date">
          <el-date-picker
            v-model="jfDate"
            type="daterange"
            @change="handleChangeTime"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch1">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <p>累计积分：{{ allIntegral }}</p>
      <el-table
        :data="integralList"
        show-header
        border
        style="width: 100%"
      >
        <el-table-column type="index" align="center" label="序号" />
        <el-table-column prop="createTime" align="center" label="时间" />
        <el-table-column align="center" label="任务">
          <template slot-scope="scope">{{
            formatType(scope.row.operationType)
          }}</template>
        </el-table-column>
        <el-table-column prop="operationIntegral" align="center" label="积分">
          <template slot-scope="scope">
            <p v-if="scope.row.operationWay == 2">
              -{{ scope.row.operationIntegral }}
            </p>
            <p v-if="scope.row.operationWay == 1">
              +{{ scope.row.operationIntegral }}
            </p>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowJfPup = false">取 消</el-button>
        <el-button type="primary" @click="isShowJfPup = false">确 定</el-button>
      </div>
      <div class="pager">
        <el-pagination
          :current-page.sync="jfQueryParams.pageNum"
          :page-size="jfQueryParams.pageSize"
          @size-change="jfBarSizeChange"
          @current-change="jfBarCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50]"
          background
          layout="total, sizes, prev, pager, next"
          :total="integralTotal"
        ></el-pagination>
      </div> </el-dialog
    >
    <el-dialog
      title="现金账户明细"
      :visible.sync="isShowAmountShowJfPup"
      top="4vh"
    >
      <el-form :inline="true" ref="jfQueryParams" class="demo-form-inline">
        <el-form-item label="时间" prop="date">
          <el-date-picker
            v-model="jfDate"
            type="daterange"
            @change="handleChangeTime"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch1">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="money_middle">
        <p>可提现约：{{ memberAccount.usableAmount }}</p>
        <p>累计提现：{{ memberAccount.allWithdrawDeposit }}</p>
      </div>
      <el-table
        :data="integralList"
        show-header
        border
        style="width: 100%"
      >
        <el-table-column type="index" align="center" label="序号" />
        <el-table-column prop="createTime" align="center" label="时间" />
        <el-table-column align="center" label="类型">
          <template slot-scope="scope">{{
            formatMoneyType(scope.row.operationType)
          }}</template>
        </el-table-column>
        <el-table-column prop="operationIntegral" align="center" label="金额">
          <template slot-scope="scope">
            <p v-if="scope.row.operationWay == 2">
              -{{ scope.row.operationMoney }}
            </p>
            <p v-if="scope.row.operationWay == 1">
              +{{ scope.row.operationMoney }}
            </p>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          :current-page.sync="jfQueryParams.pageNum"
          :page-size="jfQueryParams.pageSize"
          @size-change="jfBarSizeChange"
          @current-change="jfBarCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50]"
          background
          layout="total, sizes, prev, pager, next"
          :total="integralTotal"
        ></el-pagination>
      </div>
      <div  slot="footer" class="dialog-footer">
        <el-button @click="isShowAmountShowJfPup = false">取 消</el-button>
        <el-button type="primary" @click="isShowAmountShowJfPup = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-scrollbar>
</template>
<script>
import areaPicker from "@/components/common/form/area_picker";
import { memberArchiveSaveOrUpdateRecord, memberLabelRelation, getMemberInfoByPhoneNum } from "@/api/system/member";
import {
  getMemberIntegral,
  memberTotalIntegral,
  getMemberTotalMoney
} from "@/api/ykfApi/request";
export default {
  props: {
    path: {
      type: String,
      default() {
        return 'memberDetail'
      }
    },
    visitDetail: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      default() {
        return 1
      },
      type: Number
    },
    memberEditData: {
      // 会员数据
      default() {
        return {}
      },
      type: Object
    },
    storeList: {
      // 门店列表
      default() {
        return []
      },
      type: Array
    },
    id: {
      // 工单列表id
      default(){
        return 0
      },
      type: Number
    },
    memberId: {
      type: Number,
      required: true
    }
  },
  data() {
     var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号'));
        }else if(/^[1][3,4,5,7,8][0-9]{9}$/.test(value)) {
          callback();
        }
        else {
          callback(new Error('请输入正确手机号'));
        }
      };
     var validateId = (rule, value, callback) => {
        if (value === '' || value === undefined) {
          callback(new Error('请输入身份证号'));
        }else if(/^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/.test(value)) {
          callback();
        }
        else {
          callback(new Error('请输入正确身份证号'));
        }
      };
    return {
      loading: false,
      memberLabelList: [],
      rules: {
        idNo:[{required: true, validator: validateId, trigger: ['blur','change']}],
        photoNumber:[{required: true,validator: validatePhone, trigger: 'blur'}],
        height:[{required: true, message: '不能为空', trigger: 'blur'}],
        weight:[{required: true, message: '不能为空', trigger: 'blur'}],
        medicalInsuranceCardNumber:[{required: true, message: '不能为空', trigger: 'blur'}],
        memberRemark:[{required: true, message: '不能为空', trigger: 'blur'}],
        bmi:[{required: true, message: '不能为空', trigger: 'blur'}],
        bloodType:[{required: true, message: '不能为空', trigger: 'blur'}],
        nation:[{required: true, message: '不能为空', trigger: 'blur'}],
        nativePlace:[{required: true, message: '不能为空', trigger: 'blur'}],
        homeAddress:[{required: true, message: '不能为空', trigger: 'blur'}],
      },
      memberTag: [],
      areaList: [],
      ruleForm: {
      },
      isShowJfPup: false,
      isShowAmountShowJfPup: false,
      jfQueryParams: {
        pageNum: 1,
        pageSize: 10,
        memberId: null,
        beginTime: null,
        endTime: null
      },
      jfDate: [],
      allIntegral: 0,
      integralList: [],
      integralTotal: null,
      memberAccount: {},
    };
  },
  created() {
    this.totalIntegral();
    this.MemberTotalMoney();
    this.handleMemberLabelRelation()
  },
  components: {
    areaPicker
  },
  watch: {
    isShowJfPup(n, o) {
      if (n == true) {
        this.jfQueryParams = {
          pageNum: 1,
          pageSize: 10,
          memberId: null,
          beginTime: null,
          endTime: null
        };
        this.jfDate = [];
        this.MemberIntegral();
      }
    },
    isShowAmountShowJfPup(n, o) {
      if (n == true) {
        this.jfDate = [];
        this.jfQueryParams = {
          pageNum: 1,
          pageSize: 10,
          memberId: null,
          beginTime: null,
          endTime: null
        };
        this.MemberIntegral();
      }
    },
    visitDetail: {
      handler: function(val) {
        val.forEach(item => {
          const obj = {};
          if (typeof item.children === "object") {
            this.$set(this.ruleForm, item.nodeCode, {});
            item.children.forEach(sub => {
              if (sub.nodeCode === "lifeStyleGuidance:motion") {
                this.$set(this.ruleForm, "someTime1", sub.inputValues?.input1);
                this.$set(this.ruleForm, "someTime2", sub.inputValues?.input2);
              } else if(sub.inputValueFormat === 2) { //设置为数组类型
                 this.$set(
                  this.ruleForm[item.nodeCode],
                  sub.nodeCode,
                  sub.inputValues?sub.inputValues: []
                );
              }
              else {
                this.$set(
                  this.ruleForm[item.nodeCode],
                  sub.nodeCode,
                  sub.inputValues
                );
              }
            });
          }
        });
      },
      immediate: true
    },
    memberEditData: {
      handler: function(val) {
        const {
          memberName,
          memberSex,
          birthday,
          idNo,
          photoNumber,
          height,
          weight,
          medicalInsuranceCardNumber,
          memberRemark,
          bmi,
          bloodType,
          nation,
          nativePlace,
          homeAddress,
          province,
          city,
          area,
          memberAddress
        } = val;
        for (let key in {
          memberName,
          memberSex,
          birthday,
          idNo,
          photoNumber,
          height,
          weight,
          medicalInsuranceCardNumber,
          memberRemark,
          bmi,
          bloodType,
          nation,
          nativePlace,
          homeAddress,
          province,
          city,
          area,
          memberAddress
        }) {
          // console.log(key,'key');
          this.$set(this.ruleForm, key, val[key]);
        }
      },
      immediate: true
      // deep: true
    }
  },
  computed: {
    memberDetail() {
      //console.log('memberEditData==============', this.memberEditData)
      this.areaList = [];
      if (this.memberEditData) {
        if (
          this.memberEditData.province &&
          this.memberEditData.city &&
          this.memberEditData.area
        ) {
          this.areaList = [
            this.memberEditData.province,
            this.memberEditData.city,
            this.memberEditData.area
          ];
        }
      }
      return this.memberEditData;
    } 
  },
  methods: {
    /**
     * 检查手机号是否重复
     */
    handleRepetition(event) {
      // console.log('handleRepetition====>', event);
      let reg = /^[1][3,4,5,7,8][0-9]{9}$/
      if(reg.test(this.ruleForm.photoNumber)) {
        getMemberInfoByPhoneNum({phoneNum: this.ruleForm.photoNumber}).then(res => {
          if(res.data) {
            this.$message.warning(res.msg)
            this.ruleForm.photoNumber = ''
          }else {
            this.$message.success(res.msg)
          }
        })
      }
    },
    checkForm() {
      return new Promise((resolve, reject) => {
        const ruleFormElement = this.$refs['ruleForm']
        ruleFormElement.validate((valid) => {
          if (valid) {
            // alert('submit!');
            resolve(this.formatData(this.ruleForm))
          } else {
            console.log('error submit!!');
            reject('表单尚未填写完整')
            return false;
          }
        });
      })
    },
    /**
     * 重置表单
     */
    reset() {
      this.$refs['ruleForm'].resetFields()
      for(let key in this.ruleForm) {
        if(key.indexOf(':') === -1) {
          this.ruleForm[key] = undefined
        }else {
          const obj = this.ruleForm[key]
          for(let key2 in obj) {
            // console.log(obj[key2]);
            // console.log(typeof obj[key2]);
            if(Object.prototype.toString.call(obj[key2]).slice(8,-1) === 'Array') {
              obj[key2] = []
            }else {
              obj[key2] = undefined
            }
          }
        }
      }
    },
    /**
     * 查询慢病标签
     */
    handleMemberLabelRelation() {
      memberLabelRelation({pageNum: 1, pageSize: 100, memberId: this.memberId}).then(res => {
        if(res.code === 200) {
          this.memberLabelList = res.data?.records?res.data.records: []
        }
      })
    },
    /**
     * 积分明细接口
     */
    // 积分明细
    MemberIntegral() {
      //console.log('id====', this.isShowJfPup)
      this.jfQueryParams.memberId = this.memberId;
      let url = "";
      if (this.isShowJfPup == true) {
        url = "/system/memberIntegralOperationDetail/list";
      } else {
        url = "/system/memberAccountOperationDetail/list";
      }
      // console.log('this.jfQueryParams=====>',this.jfQueryParams);
      getMemberIntegral(url, this.jfQueryParams).then(res => {
        //console.log(res);
        if (res.code == 200) {
          this.integralList = res.data.records;
          this.integralTotal = res.data.total;
        }
      });
    },
    // 查询会员积分
    totalIntegral() {
      let params = {
        memberId: this.memberId
      };
      memberTotalIntegral(params).then(res => {
        if (res.code == 200) {
          this.allIntegral = (res.data && res.data.allIntegral) || 0;
        }
      });
    },
    // 查询会员余额
    MemberTotalMoney() {
      let params = {
        memberId: this.memberId
      };
      getMemberTotalMoney(params).then(res => {
        if (res.code == 200) {
          this.memberAccount = res.data;
        }
      });
    },
    // 积分任务格式化
    formatType(type) {
      return {
        1: "签到",
        2: "补卡",
        3: "兑换礼品",
        4: "积分过期",
        5: "注册",
        6: "连续签到赠送",
        7: "补签扣3积分，连续加5积分",
        8: "会员任务打卡"
      }[type];
    },
    // 查询
    onSearch1() {
      this.jfQueryParams.pageNum = 1;
      this.jfQueryParams.pageSize = 10;
      this.MemberIntegral();
    },
    // 重置
    onReset() {
      this.jfQueryParams = {
        pageNum: 1,
        pageSize: 10,
        memberId: null,
        beginTime: null,
        endTime: null
      };
      this.jfDate = [];
      this.MemberIntegral();
    },
    showJfPup() {
      // 显示积分弹窗
      this.isShowJfPup = true;
    },
    // 时间
    handleChangeTime(val) {
      //console.log(val);
      this.jfQueryParams.beginTime =
        this.formatDate(val[0].getTime()) + " 00:00:00";
      this.jfQueryParams.endTime =
        this.formatDate(val[1].getTime()) + " 23:59:59";
      //console.log(this.jfQueryParams)
    },
    /**
     * 格式化时间
     */
    formatDate(dateTime) {
      // debugger
      let date = new Date(dateTime);
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();

      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      //console.log(myyear + "-" + mymonth + "-" + myweekday)
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    jfBarSizeChange(val) {
      this.jfQueryParams.pageSize = val;
      // this.getMemberList();
      this.MemberIntegral();
    },
    jfBarCurrentChange(val) {
      this.jfQueryParams.pageNum = val;
      this.MemberIntegral();
    },
    showAmountPup() {
      // 显示积分弹窗
      this.isShowAmountShowJfPup = true;
    },
    formatMoneyType(type) {
      return {
        1: "现金返现",
        2: "余额提现",
        3: "活动订单",
        4: "退款"
      }[type];
    },
    getrelation(type) {
      return {
        0: "父亲",
        1: "母亲",
        2: "儿子",
        3: "女儿",
        4: "配偶"
      }[type];
    },
    handleChange() {},
    editClick() {
      this.$emit("handleEdit", 2);
    },
    //
    // 预览
    onPreview() {
      setTimeout(() => {
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    handleChange(value, type) {
      // console.log(value);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    initAreaForm() {
      // 初始化表单省市区
      this.ruleForm.province = "";
      this.ruleForm.city = "";
      this.ruleForm.area = "";
    },
    getAreaData(item) {
      // 获取省市区 length=3 省市区 length=2 省区
      // debugger
      this.areaList = item.codes;
      this.initAreaForm();
      if (item.codes.length === 3) {
        this.ruleForm.province = item.codes[0];
        this.ruleForm.city = item.codes[1];
        this.ruleForm.area = item.codes[2];
        this.ruleForm.memberAddress =
          item.names[0] + "," + item.names[1] + "," + item.names[2];
      } else {
        this.ruleForm.province = item.codes[0];
        this.ruleForm.area = item.codes[1];
        this.ruleForm.memberAddress = item.names[0] + "," + item.names[1];
      }
      //console.log(this.form);
    },

    //
    changeStoreId(val) {
      //console.log(val)
      this.memberDetail.storeId = val.id;
      this.memberDetail.storeName = val.storeName;
    },
    onCancel() {
      this.$emit("handleEdit", 1);
      this.$emit(
        "onSaveSuccess",
        this.memberDetail.memberId,
        this.memberDetail.enterpriseId
      );
    },
    // 获取省市区地址
    getAddress(val) {
      this.memberDetail.memberAddress = val;
    },
    /**
     * 格式化时间
     */
    formatDate(dateTime) {
      // debugger
      let date = new Date(dateTime);
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();

      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    // 生日
    onChangeBirth(val) {
      this.memberDetail.birthday = this.formatDate(val);
      //console.log(this.memberDetail.birthday)
    },
    // 封装数据
    formatData(data) {
      const arr = [];
      let count = 0;
      const recursion = function(obj) {
        for (let key in obj) {
          if (Object.prototype.toString.call(obj[key]).slice(8,-1)  === "Object") {
            recursion(obj[key]);
          } else {
            if (key.indexOf(":") !== -1) {
              arr.push({
                nodeCode: key,
                nodeInputs: obj[key],
                remark: ""
              });
            }
          }
        }
      };
      recursion(data);
      return arr;
    },
    // 保存
    onSave() {
      const flag = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      this.loading = true
      let memberInfo = {};
      for (let key in this.ruleForm) {
        if (key.indexOf(":") === -1) {
          memberInfo[key] = this.ruleForm[key];
        }
      }
      const archiveRecord = {
        bizKeyCode: this.memberId,
        remark: "",
        children: this.formatData(this.ruleForm)
      };
      console.log(this.formatData(this.ruleForm));
      memberArchiveSaveOrUpdateRecord({
        memberInfo,
        archiveRecord,
        memberId: this.memberId
      }).then(res => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      }).finally(_=>{
        this.loading = false
        this.$emit("handleEdit", 1);
      })
    }
  }
};
</script>
<style lang="less" scoped>
.notice {
  color: #f56c6c;
  font-size: 14px;
}
.illnessType {
  font-size: 14px;
  color: gray;
  margin-left: 10px;
}
.btn {
  margin: 20px;
  width: calc(100% - 40px);
  text-align: center;
}
.content {
  height: 450px;
  // overflow: auto;
  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
}
.information /deep/ .el-collapse-item__header {
  background: #e6ebf5;
  padding-left: 10px;
  font-weight: bold;
}
.slot_title {
  display: flex;
  align-items: center;
  p:nth-child(1) {
    width: 4px;
    height: 22px;
    background: #46a6ff;
    border-radius: 6px;
    margin-right: 10px;
  }
}
.person_info {
  //   padding: 20px;
  //   padding-left: 50px;
  //   margin-bottom: 20px;
  .header {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding: 10px 4px;
    background: #e8f4ff;
    h4 {
      margin: 0;
      padding: 0;
      margin-right: 20px;
    }
  }
  h4 {
    // margin: 0;
    padding: 10px 4px;
    background: #e8f4ff;
    font-weight: normal;
  }
  .item {
    display: flex;
    // justify-content: space-between;
    width: 100%;
    align-items: center;

    p {
      width: 50%;
      font-size: 14px;
      //   padding-right: 100px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      span:nth-child(1) {
        display: inline-block;
        width: 100px;
        text-align: left;
        /deep/ .el-tag--medium {
          margin-right: 10px;
        }
        // margin-right: 10px;
      }
      .require:before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
      }
      /deep/ .el-input {
        width: 50%;
      }
    }
    .store {
      /deep/ .el-input {
        width: 100%;
      }
    }
    .remark {
      width: 100%;
    }
  }
}
.footer {
  padding: 20px;
  //   padding-left: 50px;
  .img {
    width: 100px;
    height: 100px;
    margin-right: 20px;
  }
}
.tip {
  color: #f56c6c;
  margin-left: 10px;
}
</style>
